import CompanyClientsDetailsData from './CompanyClientsDetailsData';

export default CompanyClientsDetailsData;
